export { empty } from "./empty.js";
export { from } from "./from.js";
export { split } from "./split.js";
export { concat } from "./concat.js";
export { execute } from "./execute.js";
export { ApolloLink } from "./ApolloLink.js";
export * from "./types.js";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/link/core/index.js
// module id = ./node_modules/@apollo/client/link/core/index.js
// module chunks = 53 54